// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"167":"054bd03b","3094":"054bd03b","3279":"054bd03b"}[chunkId] + ".chunk.css";
};